import _ from "lodash";
import React from "react";
import classes from "./DescriptorTableV2.scss";
import FeedListv2 from "AppComponents/FeedListv2";

const getCustomHeaderComponent = ({ column }) => {
  const { label } = column;
  return <div className={classes.descriptorTableHeader}>{label}</div>;
};

const getCustomComponent = ({ columnData }) => {
  if (columnData) {
    return (
      <div
        className={classes.wrapText}
        dangerouslySetInnerHTML={{
          __html: columnData,
        }}
      />
    );
  }
};

const DescriptorTableV2 = ({ flatListedAssessmentTool, criteriaId, t }) => {
  const { criteria, descriptors } = flatListedAssessmentTool;

  const parentCriteria = _.find(criteria, { id: criteriaId }) || {};

  const columnList = {};

  const commonColumnStyle = {
    width: "144px",
    verticalAlign: "top",
  };

  const commonColumConfig = {
    showCustomHeader: true,
    dataConfig: { dataType: "CUSTOM" },
    alignment: "left",
    style: commonColumnStyle,
    type: "CUSTOM",
    uiConfig: {
      uiType: "CUSTOM",
    },
  };

  const criterionLabel = _.get(parentCriteria, "label", "");

  columnList[criteriaId] = {
    id: criteriaId,
    label: _.chain(criterionLabel).split(":").first().trim().value(),
    dataConfig: { dataType: "CUSTOM" },
    alignment: "left",
    ...commonColumConfig,
  };

  const markBands = _.chain(descriptors)
    .filter(({ objective }) => objective?.parent === criteriaId)
    .map("achievementLevel")
    .uniqBy("id")
    .sortBy("displaySequence")
    .value();

  _.forEach(markBands, markBand => {
    const { id: achievementLevelId, label: achievementLevelLabel } = markBand;
    columnList[achievementLevelId] = {
      id: achievementLevelId,
      label: t("project:label_with_marks", { label: achievementLevelLabel }),
      ...commonColumConfig,
    };
  });

  const feedData = [];

  const criteriaObjectives = _.chain(descriptors)
    .filter(({ objective }) => objective?.parent === criteriaId)
    .map("objective")
    .uniqBy("id")
    .sortBy("displaySequence")
    .value();

  _.forEach(criteriaObjectives, objective => {
    const { id: objectiveId, label: objectiveLabel } = objective;
    feedData.push({
      [criteriaId]: objectiveLabel,
    });

    _.forEach(markBands, markBand => {
      const { id: achievementLevelId } = markBand;
      const descriptor = _.find(descriptors, {
        objective: { id: objectiveId },
        achievementLevel: { id: achievementLevelId },
      });
      const descriptorLabel = _.get(descriptor, "label", "");
      feedData[_.size(feedData) - 1][achievementLevelId] = descriptorLabel;
    });
  });

  return (
    <div>
      <FeedListv2
        columnList={columnList}
        feedData={feedData}
        tableSize="medium"
        headerTheme="subtle"
        showBorder={true}
        shoeHeaderRow={true}
        showLastRowBorder={true}
        showRowBackgroundOnHover={false}
        getCustomComponent={getCustomComponent}
        getCustomHeaderComponent={getCustomHeaderComponent}
        dsVersion={"2.0"}
      />
    </div>
  );
};

export default DescriptorTableV2;
